import { Box, Flex, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import TabelaItemComposicao from "../TabelaItemComposicao";
import { RelatorioComposicaoContasItem } from "core/features/relatorios/conta-com-composicoes/typings";
import { OperacaoEnum } from "resources/enums/conta";
import { formatBlocoQuadra } from "infra/helpers/formatBlocoQuadra";

export interface ItemComposicaoProps {
  item: RelatorioComposicaoContasItem;
  operacao: OperacaoEnum;
}

function ItemComposicao({ item, operacao }: ItemComposicaoProps) {
  return (
    <Box>
      <Flex
        bg={colors.lightBlue}
        py={1}
        pr={6}
        pl={2}
        alignItems="center"
        borderBottom={`1px solid ${colors.gray}`}
      >
        <Flex alignItems="center" h="40px"></Flex>
        <Text ml={1} fontWeight="medium" fontSize="16px">
          {item.unidade
            ? formatBlocoQuadra(item.unidade, item.blocoQuadra, "") + " - "
            : ""}
          {item.nome}
        </Text>
        {item.pessoaOperadorAcordo?.nome ? (
          <Text ml={"auto"} fontWeight="medium" fontSize="16px">
            Operador: {item.pessoaOperadorAcordo.nome}
          </Text>
        ) : null}
      </Flex>

      <Box>
        <TabelaItemComposicao item={item} operacao={operacao} />
      </Box>
    </Box>
  );
}

export default ItemComposicao;
